import { render, staticRenderFns } from "./workerForm.vue?vue&type=template&id=7f50f827&"
import script from "./workerForm.vue?vue&type=script&lang=ts&"
export * from "./workerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports